// ============================================================
// SideQuests - Official social profiles (single source of truth)
//
// Mirrors SOCIAL_LINKS in quickgigs/scripts/site/site-content.mjs so the
// build-time crawlable pages and the React app agree. Only confirmed official
// profiles are listed. No Instagram or X are added until exact official
// addresses are supplied.
// ============================================================

export interface SocialLink {
  platform: string;
  url: string;
}

export const SOCIAL_LINKS: SocialLink[] = [
  { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61592757490023' },
  { platform: 'TikTok', url: 'https://www.tiktok.com/@trysidequests' },
  { platform: 'YouTube', url: 'https://www.youtube.com/@TrySideQuests' },
  { platform: 'Nextdoor', url: 'https://nextdoor.com/page/sidequests-bristol-ri' },
  { platform: 'Reddit', url: 'https://www.reddit.com/r/TrySideQuests/' },
  { platform: 'LinkedIn', url: 'https://www.linkedin.com/company/143782022/' },
];

export function getSocialLinks(): SocialLink[] {
  return SOCIAL_LINKS;
}
